<template>
  <div>
    <GameProjectList :id="id"/>
  </div>
</template>

<script>
import GameProjectList from './components/GameProjectList.vue';

export default {
  name: 'GameProject',
  components: {
    GameProjectList,
  },
  props: {
    id: {
      type: String,
      default: null,
    },
  },
};
</script>
